import React from "react";
import Slider from "react-slick";

const reviews = [
  {
    author: "Marie-Nella",
    rating: 4.8,
    text: "J’ai confié à Delphia la réalisation de mes bouquets pour la mairie et la bénédiction nuptiale. Elle a su créer deux compositions fidèles à mes souhaits… jusqu’aux demandes de dernière minute pour la décoration florale de la voiture, elle a fait preuve d’une grande flexibilité. Le résultat était magnifique, original et porteur de sens.",
  },
  {
    author: "Ilona",
    rating: 4.8,
    text: "Nous avons fait appel à Delphia pour la décoration florale de notre mariage (centres de tables et compositions). Elle a été à l’écoute, très professionnelle et réactive. Le jour J, tout était absolument parfait.",
  },
  {
    author: "Pauline",
    rating: 5.0,
    text: "Delphia a su sublimer ma robe de mariée au travers de mon bouquet tombant… Le bouquet reste immortel pour notre couple. Merci pour ton professionnalisme.",
  },
  {
    author: "Aurélie",
    rating: 5.0,
    text: "Très heureuse. Elle est vraiment à l’écoute des envies et des besoins. Les bouquets étaient exactement ce que je souhaitais.",
  },
  {
    author: "O. A",
    rating: 5.0,
    text: "Delphia est une experte dans son domaine. Merci pour tout.",
  },
  {
    author: "Isabelle",
    rating: 4.8,
    text: "Très professionnelle et bienveillante, je recommande sans hésiter.",
  },
];

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,
  arrows: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        autoplay: true,         
        infinite: true           
      }
    }
  ]
};

export default function ReviewsSlider() {
  return (
    <div className="reviews-container">


      <Slider {...settings}>
        {reviews.map((rev, index) => (
          <div key={index} className="review-slide">
            <h4>{rev.author}</h4>
            <div className="stars">{rev.rating} 
              {[...Array(5)].map((_, i) => (
                <span key={i}>
                  {i < Math.round(rev.rating) ? "★" : "☆"} 
                </span>
              ))}            

            </div>
            <p>{rev.text}</p>
          </div>
        ))}
      </Slider>
    </div>
  );
}